import { classes } from 'html-classes';
import React, { ReactNode, useState } from 'react';

import { IconTypes } from '~/components/Icon/IconTypes';
import { IconButton, Variant } from '~/components/isolated/IconButton';

import styles from './CollapsibleV2.module.scss';

export interface CollapsibleV2Props {
  children?: ReactNode;
  title?: string;
  titleElem?: ReactNode;
  className?: string;
  isCollapsed?: boolean;
  innerClassName?: string;
  titleTextClassName?: string;
  titleIconClassName?: string;
  bodyContainerClassName?: string;
  dataAttributeName?: string;
  expandIconButtonVariant?: Variant;
  expandIconButtonType?: IconTypes;
}

export const CollapsibleV2: React.FC<CollapsibleV2Props> = ({
  children,
  title,
  titleElem,
  className,
  isCollapsed = true,
  innerClassName,
  titleTextClassName,
  titleIconClassName,
  bodyContainerClassName,
  dataAttributeName,
  expandIconButtonVariant = 'outline',
  expandIconButtonType = 'chevron',
}) => {
  const [isOpen, setIsOpen] = useState(!isCollapsed);
  const [isTransitionEnded, setIsTransitionEnded] = useState(!isCollapsed);

  return (
    <div
      className={classes([
        styles.collapsible,
        className,
        isOpen && styles.open,
      ])}
    >
      <div
        data-collapsable={dataAttributeName}
        className={styles.header}
        onClick={() => {
          setIsOpen((prev) => !prev);
          setIsTransitionEnded(false);
        }}
      >
        {titleElem ? (
          titleElem
        ) : (
          <>
            <p className={classes([styles.title, titleTextClassName])}>
              {title}
            </p>
            <IconButton
              icon={expandIconButtonType}
              variant={expandIconButtonVariant}
              size="XS"
              className={classes([styles.iconButton, titleIconClassName])}
            />
          </>
        )}
      </div>
      <div
        className={classes([
          styles.body,
          isTransitionEnded && styles.animated,
          isOpen && innerClassName,
        ])}
        onTransitionEnd={() => setIsTransitionEnded(true)}
      >
        <div
          className={classes([styles.bodyContainer, bodyContainerClassName])}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
